import { memo } from "react";

import cc from "classcat";
import { Row } from "@narmi/design_system";

import { getOSKeyboardShortcutText } from "../utils";
import styles from "../SearchBar.module.scss";

const KEYBOARD_SHORTCUT_TEXT = getOSKeyboardShortcutText();
const SEARCH_ICON_CLASS = cc(["narmi-icon-search", styles["search-icon"]]);

const SearchBarIcon = memo(function SearchIcon() {
  return <Row.Item shrink className={SEARCH_ICON_CLASS} />;
});

const SearchBarShortcutDisplay = memo(function SearchBarShortcut() {
  return (
    <Row.Item shrink className={styles["keyboard-shortcut"]}>
      {KEYBOARD_SHORTCUT_TEXT}
    </Row.Item>
  );
});

export { SearchBarIcon, SearchBarShortcutDisplay };
